import type { RoleMap, RoleName } from '@sae/automation';

export const ROLE_OPTIONS: readonly { value: RoleName; label: string }[] = [
  { value: 'area-id', label: 'Area' },
  { value: 'area-name', label: 'Area Name' },
  { value: 'weight', label: 'Survey Weight' },
  { value: 'stratum', label: 'Stratum' },
  { value: 'psu', label: 'PSU / Cluster' },
  { value: 'psu-population-count', label: 'Frame PSU Count' },
  { value: 'respondent-id', label: 'Respondent ID' },
  { value: 'estimate', label: 'Direct Estimate' },
  { value: 'variance', label: 'Sampling Variance' },
  { value: 'standard-error', label: 'Standard Error' },
  { value: 'sample-size', label: 'Sample Size (n)' },
  { value: 'population-count', label: 'Population Count' },
  { value: 'indicator', label: 'Indicator (Outcome)' },
  { value: 'subgroup', label: 'Subgroup Variable' },
  { value: 'covariate', label: 'Covariate' },
];

export const ROLE_LABELS: Record<RoleName, string> = Object.fromEntries(
  ROLE_OPTIONS.map((o) => [o.value, o.label]),
) as Record<RoleName, string>;

/** The role a column currently holds in the confirmed map, if any. */
export function currentRoleOf(roles: RoleMap, column: string): RoleName | null {
  if (roles.areaId === column) return 'area-id';
  if (roles.areaName === column) return 'area-name';
  if (roles.weight === column) return 'weight';
  if (roles.stratum === column) return 'stratum';
  if (roles.psu === column) return 'psu';
  if (roles.psuPopulationCount === column) return 'psu-population-count';
  if (roles.respondentId === column) return 'respondent-id';
  if (roles.estimate === column) return 'estimate';
  if (roles.variance === column) return 'variance';
  if (roles.standardError === column) return 'standard-error';
  if (roles.sampleSize === column) return 'sample-size';
  if (roles.populationCount === column) return 'population-count';
  if (roles.indicators.includes(column)) return 'indicator';
  if (roles.subgroups.includes(column)) return 'subgroup';
  if (roles.covariates.includes(column)) return 'covariate';
  return null;
}
